import { Hash } from 'lucide-react'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'

const ChannelPage = lazyPage(() => import('@/pages/Channel'), 'ChannelPage')

/**
 * F-138 Canal: one space is one channel (David, 2026-10-24), so the wizard
 * asks nothing beyond the common fields: no "one or many", no prior approval,
 * no threads switch (threads and media follow "Quem pode postar"). The new
 * space opens straight in the conversation. `/{section}/{space}/{messageId}`
 * (the bell) opens the channel at that message.
 */
export const channelModule: ModuleDefinition = {
  key: 'channel',
  icon: Hash,
  iconName: 'hash',
  namespaces: ['channels'],
  ready: true,
  opensOnCreate: true,
  ListPage: ChannelPage
}
